import './App.css';
import { IsAuthenticated } from './utils/MojaveLib';
import DefaultLayout from './components/layout/DefaultLayout';
import LoginLayout from './components/layout/LoginLayout';

const  App = () => (IsAuthenticated()) ? <DefaultLayout /> : <LoginLayout />;

export default App;
